"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _InboundCommunication = _interopRequireDefault(require("../model/InboundCommunication"));
var _Message = _interopRequireDefault(require("../model/Message"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* InboundCommunication service.
* @module api/InboundCommunicationApi
* @version 3.0
*/
var InboundCommunicationApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new InboundCommunicationApi. 
  * @alias module:api/InboundCommunicationApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function InboundCommunicationApi(apiClient) {
    _classCallCheck(this, InboundCommunicationApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Create an InboundCommunication.
   * Creates an Inbound Communication to receive communication from a customer
   * @param {Number} customerId Customer Id of the customer to raise the inbound comms against
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InboundCommunication} and HTTP response
   */
  return _createClass(InboundCommunicationApi, [{
    key: "createInboundCommsWithHttpInfo",
    value: function createInboundCommsWithHttpInfo(customerId) {
      var postBody = null;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling createInboundComms");
      }
      var pathParams = {
        'customerId': customerId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _InboundCommunication["default"];
      return this.apiClient.callApi('/customers/{customerId}/inboundcomms', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create an InboundCommunication.
     * Creates an Inbound Communication to receive communication from a customer
     * @param {Number} customerId Customer Id of the customer to raise the inbound comms against
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InboundCommunication}
     */
  }, {
    key: "createInboundComms",
    value: function createInboundComms(customerId) {
      return this.createInboundCommsWithHttpInfo(customerId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Modify an InboundCommunciation.
     * Add content to an Inbound Communication – for example filling in information for a survey sent out by the SR-SSB.
     * @param {Number} customerId Customer Id of the customer to raise the inbound comms against
     * @param {Number} inboundcommsId InboundComms ID of the Survey
     * @param {module:model/InboundCommunication} inboundCommunication Survey details
     * @param {Object} opts Optional parameters
     * @param {Number} [pageId = -1)] Page Id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InboundCommunication} and HTTP response
     */
  }, {
    key: "modifyInboundCommsWithHttpInfo",
    value: function modifyInboundCommsWithHttpInfo(customerId, inboundcommsId, inboundCommunication, opts) {
      opts = opts || {};
      var postBody = inboundCommunication;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling modifyInboundComms");
      }
      // verify the required parameter 'inboundcommsId' is set
      if (inboundcommsId === undefined || inboundcommsId === null) {
        throw new Error("Missing the required parameter 'inboundcommsId' when calling modifyInboundComms");
      }
      // verify the required parameter 'inboundCommunication' is set
      if (inboundCommunication === undefined || inboundCommunication === null) {
        throw new Error("Missing the required parameter 'inboundCommunication' when calling modifyInboundComms");
      }
      var pathParams = {
        'customerId': customerId,
        'inboundcommsId': inboundcommsId
      };
      var queryParams = {
        'pageId': opts['pageId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _InboundCommunication["default"];
      return this.apiClient.callApi('/customers/{customerId}/inboundcomms/{inboundcommsId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Modify an InboundCommunciation.
     * Add content to an Inbound Communication – for example filling in information for a survey sent out by the SR-SSB.
     * @param {Number} customerId Customer Id of the customer to raise the inbound comms against
     * @param {Number} inboundcommsId InboundComms ID of the Survey
     * @param {module:model/InboundCommunication} inboundCommunication Survey details
     * @param {Object} opts Optional parameters
     * @param {Number} opts.pageId Page Id (default to -1)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InboundCommunication}
     */
  }, {
    key: "modifyInboundComms",
    value: function modifyInboundComms(customerId, inboundcommsId, inboundCommunication, opts) {
      return this.modifyInboundCommsWithHttpInfo(customerId, inboundcommsId, inboundCommunication, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();